import apiHandler from "../../../../api/core/apiHandler";

const PayableApi = apiHandler("payables");

export default PayableApi;